import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../../shared/services/auth.service';

/**
 * Landing route for SSO invitation links (`/login?email=...`). It immediately starts the Keycloak
 * login, passing the invited email as `login_hint` so the login page is prefilled and — for an SSO
 * tenant — Keycloak routes the user to their identity provider by email domain (Organizations).
 * Users who already have a session are sent straight into the app.
 */
@Component({
  selector: 'app-sso-login',
  template: `
    <div class="sso-login">
      <p>Redirecting to sign in…</p>
    </div>
  `,
  styles: [
    `
      .sso-login {
        max-width: 400px;
        margin: 80px auto;
        text-align: center;
      }
    `,
  ],
})
export class SsoLoginComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  async ngOnInit(): Promise<void> {
    const email = this.route.snapshot.queryParamMap.get('email') ?? undefined;

    if (this.authService.isAuthenticated()) {
      await this.router.navigateByUrl('/');
      return;
    }

    await this.authService.login('/', email);
  }
}
